import React, { useEffect, useState } from "react";
import TestRoom from "../resources/test-room.svg";
import "./ConventionMap.css";

const ConventionMap = (props) => {
  const [conventionData, setConventionData] = useState({});
  const [selectedRoom, setSelectedRoom] = useState("");

  useEffect(() => {}, []);

  const blankFill = "white";
  const fullFill = "red";

  const clickCheck = (event) => {
    if (event.target.getAttribute("fill") == blankFill) {
      event.target.setAttribute("fill", fullFill);
    } else {
      event.target.setAttribute("fill", blankFill);
    }

    // event.target.filled="#AAA"
  };
  return (
    // <div>
    //   Map
    //   <img src={TestRoom} alt="React Logo" />
    // </div>
    <svg width="800" height="600" xmlns="http://www.w3.org/2000/svg">
      <g>
        <title>Layer 1</title>
        <rect
          id="svg_8"
          height="60"
          width="66"
          y="376.33499"
          x="198"
          stroke="#000"
          fill="#ffffff"
        />
        <rect
          id="svg_10"
          height="60"
          width="66"
          y="316.33499"
          x="198"
          stroke="#000"
          fill="#ffffff"
        />
        <rect
          stroke="#000"
          id="svg_11"
          height="60"
          width="86"
          y="436.33499"
          x="178"
          fill="#ffffff"
        />
        <rect
          stroke="#000"
          id="svg_12"
          height="80"
          width="66"
          y="331.33499"
          x="98"
          fill="#ffffff"
        />
        <rect
          stroke="#000"
          id="svg_13"
          height="103"
          width="66"
          y="227.33499"
          x="99"
          fill="#ffffff"
        />
        <rect
          stroke="#000"
          id="svg_14"
          height="157.00001"
          width="134"
          y="69.33499"
          x="99"
          fill="#ffffff"
        />
        <rect
          stroke="#000"
          id="svg_15"
          height="94"
          width="159"
          y="72.33499"
          x="235"
          fill="#ffffff"
        />
        <path
          id="svg_16"
          d="m177,527.33502l86,0l0,60l-86,0l0,-30l0,-30z"
          opacity="undefined"
          stroke="#000"
          fill="#ffffff"
        />
        <path
          stroke="#000"
          id="svg_17"
          d="m393,27.335l115,0l0,137.99999l-115,0l0,-137.99999z"
          opacity="undefined"
          fill="#ffffff"
        />
        <path
          stroke="#000"
          id="svg_18"
          d="m509,27.335l46,0l0,137.99999l-46,0l0,-137.99999z"
          opacity="undefined"
          fill="#ffffff"
        />
        <path
          stroke="#000"
          id="svg_19"
          d="m611,28.335l159,0l0,212.99999l-159,0l0,-212.99999z"
          opacity="undefined"
          fill="#ffffff"
        />
        <rect
          stroke="#000"
          id="svg_20"
          height="352.00005"
          width="54"
          y="38.33502"
          x="9"
          fill="#ffffff"
        />
        <rect
          stroke="#000"
          id="svg_21"
          height="104"
          width="118.00001"
          y="480.33497"
          x="6.99999"
          fill="#ffffff"
        />
        <rect
          stroke="#000"
          id="svg_22"
          height="87"
          width="66"
          y="391.33499"
          x="10"
          fill="#ffffff"
        />
        <text
          stroke="#000"
          // xml:space="preserve"
          textAnchor="start"
          fontFamily="'Bitter'"
          fontSize="24"
          strokeWidth="0"
          id="svg_24"
          y="476.33499"
          x="215"
          fill="#000000"
        >
          C
        </text>
        <text
          stroke="#000"
          // xml:space="preserve"
          textAnchor="start"
          fontFamily="'Bitter'"
          fontSize="24"
          strokeWidth="0"
          id="svg_25"
          y="356.33499"
          x="224"
          fill="#000000"
        >
          B
        </text>
        <text
          stroke="#000"
          // xml:space="preserve"
          textAnchor="start"
          fontFamily="'Bitter'"
          fontSize="24"
          strokeWidth="0"
          id="svg_27"
          y="417.33499"
          x="221"
          fill="#000000"
        >
          A
        </text>
        <text
          style={{ cursor: "move" }}
          stroke="#000"
          // xml:space="preserve"
          textAnchor="start"
          fontFamily="'Bitter'"
          fontSize="12"
          strokeWidth="0"
          id="svg_28"
          y="549.33499"
          x="193"
          fill="#000000"
        >
          Executive
        </text>
        <text
          style={{ cursor: "move" }}
          stroke="#000"
          // xml:space="preserve"
          textAnchor="start"
          fontFamily="'Bitter'"
          fontSize="12"
          strokeWidth="0"
          id="svg_29"
          y="569.33499"
          x="193"
          fill="#000000"
        >
          Boardroom
        </text>
        <text
          stroke="#000"
          // xml:space="preserve"
          textAnchor="start"
          fontFamily="'Bitter'"
          fontSize="12"
          id="svg_31"
          y="243.33499"
          x="112"
          strokeWidth="0"
          fill="#000000"
        >
          Fraiser
        </text>
        <text
          stroke="#000"
          // xml:space="preserve"
          textAnchor="start"
          fontFamily="'Bitter'"
          fontSize="12"
          id="svg_32"
          y="258.33499"
          x="112"
          strokeWidth="0"
          fill="#000000"
        >
          North
        </text>
        <text
          stroke="#000"
          // xml:space="preserve"
          textAnchor="start"
          fontFamily="'Bitter'"
          fontSize="12"
          id="svg_33"
          y="353.33499"
          x="106"
          strokeWidth="0"
          fill="#000000"
        >
          Fraiser
        </text>
        <text
          stroke="#000"
          // xml:space="preserve"
          textAnchor="start"
          fontFamily="'Bitter'"
          fontSize="12"
          id="svg_34"
          y="368.33499"
          x="106"
          strokeWidth="0"
          fill="#000000"
        >
          South
        </text>
        <text
          // xml:space="preserve"
          textAnchor="start"
          fontFamily="'Bitter'"
          fontSize="24"
          id="svg_37"
          y="94.33499"
          x="620"
          strokeWidth="0"
          stroke="#000"
          fill="#000000"
        >
          Westminster
        </text>
        <text
          // xml:space="preserve"
          textAnchor="start"
          fontFamily="'Bitter'"
          fontSize="24"
          id="svg_38"
          y="142.33499"
          x="638"
          strokeWidth="0"
          stroke="#000"
          fill="#000000"
        >
          Ballroom
        </text>
        <text
          stroke="#000"
          // xml:space="preserve"
          textAnchor="start"
          fontFamily="'Bitter'"
          fontSize="24"
          id="svg_39"
          y="140.33499"
          x="118"
          strokeWidth="0"
          fill="#000000"
        >
          Tivoli's II
        </text>
      </g>
    </svg>

    // <svg width="800" height="600" xmlns="http://www.w3.org/2000/svg">
    //   <g>
    //     <title>Layer 1</title>
    //     <rect
    //       id="Main Room"
    //       className="convention-room"
    //       height="395"
    //       width="331"
    //       y="111.33499"
    //       x="61"
    //       stroke="#000"
    //       fill={fullFill}
    //       onClick={clickCheck}
    //     />
    //     <rect
    //       id="Side Room"
    //       height="397"
    //       width="319"
    //       y="113.33499"
    //       x="430"
    //       stroke="#000"
    //       fill="#fff"
    //       onClick={clickCheck}
    //     />
    //     <rect
    //       id="Back Room"
    //       height="76"
    //       width="432"
    //       y="10.33499"
    //       x="212"
    //       stroke="#000"
    //       fill={blankFill}
    //       onClick={clickCheck}
    //     />
    //     <text
    //       fontFamily="Noto Sans JP"
    //       fontSize="24"
    //       id="svg_4"
    //       y="300"
    //       x="246"
    //       strokeWidth="0"
    //       stroke="#000"
    //       fill="#000000"
    //     >
    //       Main Room
    //     </text>
    //     <text
    //       stroke="#000"
    //       fontFamily="Noto Sans JP"
    //       fontSize="24"
    //       id="svg_5"
    //       y="54"
    //       x="358"
    //       strokeWidth="0"
    //       fill="#000000"
    //     >
    //       Side ROom
    //     </text>
    //     <text
    //       stroke="#000"
    //       fontFamily="Noto Sans JP"
    //       fontSize="24"
    //       id="svg_6"
    //       y="291"
    //       x="527"
    //       strokeWidth="0"
    //       fill="#000000"
    //     >
    //       Back Room
    //     </text>
    //   </g>
    // </svg>
  );
};
export default ConventionMap;
